import moment from 'moment';

const mixinLoadData = {
  methods: {
    loadData() {
      let data = {
        farm: this.model.farm_ids,
        lot: this.model.lot_ids,
        ribbon: this.model.ribbons_id,
        datei: null,
        datef: null,
        bySel: this.model.bySel,
        associations: [],
        businesses: [],
        zones: [],
        subzones: [],
        croptypes: [],
        crops: [],
        users: [],
        workers: [],
        calendar_sel: this.model.calendar_sel,
        comparate: this.model.comparate,
      };

      if (this.model.comparate) {
        data.dateIComparate = null;
        data.dateFComparate = null;
      }

      if (this.filterOfAssociation)
        data.associations = this.model.association_ids;
      if (this.filterOfBusinesses) data.businesses = this.model.businesses_ids;
      if (this.filterOfZones) data.zones = this.model.zone_ids;
      if (this.filterOfSubZones) data.subzones = this.model.subzone_ids;
      if (this.filterOfCropTypes) data.croptypes = this.model.croptypes_ids;
      if (this.filterOfCrops) data.crops = this.model.crops_ids;
      if (this.filterOfUsers) data.users = this.model.users_ids;
      if (this.filterOfWorkers) data.workers = this.model.workers_ids;

      const { bySel } = this.model;
      const [datei, datef] = this.rangeDate;
      const [dateIComparate, dateFComparate] = this.rangeDateComparate;
      let toFormat = 'YYYY-MM-DD';

      switch (bySel) {
        case 'Año':
          data.datei = this.model.year_sel_init;
          data.datef = this.model.year_sel_end;

          if (this.model.comparate) {
            data.dateIComparate = this.model.comp_year_sel_init;
            data.dateFComparate = this.model.comp_year_sel_end;
          }

          break;
        case 'Mes':
          data.datei = moment(datei).format(toFormat);
          data.datef = moment(datef).endOf('month').format(toFormat);

          if (this.model.comparate) {
            data.dateIComparate = moment(dateIComparate).format(toFormat);
            data.dateFComparate = moment(dateFComparate)
              .endOf('month')
              .format(toFormat);
          }

          break;
        case 'Semana':
          data.datei = `${this.model.year_sel_init}-${(
            '0' + this.model.week_sel_init
          ).slice(-2)}`;
          data.datef = `${this.model.year_sel_end}-${(
            '0' + this.model.week_sel_end
          ).slice(-2)}`;

          if (this.model.comparate) {
            data.dateIComparate = `${this.model.comp_year_sel_init}-${(
              '0' + this.model.comp_week_sel_init
            ).slice(-2)}`;
            data.dateFComparate = `${this.model.comp_year_sel_end}-${(
              '0' + this.model.comp_week_sel_end
            ).slice(-2)}`;
          }

          break;
        case 'Día':
          data.datei = moment(datei).format(toFormat);
          data.datef = moment(datef).format(toFormat);

          if (this.model.comparate) {
            data.dateIComparate = moment(dateIComparate).format(toFormat);
            data.dateFComparate = moment(dateFComparate).format(toFormat);
          }

          break;
        default:
          toFormat = 'YYYY-MM-DD HH:mm:ss';
          data.datei = moment(datei).format(toFormat);
          data.datef = moment(datef).format(toFormat);

          if (this.model.comparate) {
            data.dateIComparate = moment(dateIComparate).format(toFormat);
            data.dateFComparate = moment(dateFComparate).format(toFormat);
          }
          break;
      }

      return data;
    },
  },
};

export default mixinLoadData;
